<template>
  <v-flex xs12 mb-2>
    <v-card class="e-elevation--3 radius">
      <v-card-text class="e-calendario">
        <div class="e-sub-sub-title-md black--white d-flex align-center">{{ numero }}</div>
        <div c>
          <p class="e-description-middle mb-0 text-xs-left mb-0">{{ diaKr }}</p>
          <p class="parrafo-small mb-0 text-xs-left">{{ diaEn }}</p>
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'CardCalendario',
  data () {
    return {
      seen: true
    }
  },
  props: {
    diaKr: {
      type: String,
      default: ''
    },
    numero: {
      type: Number,
      default: 0
    },
    diaEn: {
      type: String,
      default: ''
    }
  },
  methods: {
    seleccionarRespuesta () {
      this.seen = !this.seen
    }
  }
}
</script>
